<template>
    <div class="hello">
      <a-layout>
        <!-- <a-layout-header >  
          <headerHeader></headerHeader>
        </a-layout-header> -->
        <a-layout-content>
          <!-- <div>
            <registerHome ></registerHome>
          </div> -->
          <div style="padding-top:4%">
            <!-- <register></register> -->
            <router-view/>
          </div>
        </a-layout-content>
        <a-layout-footer>
          <footerHome></footerHome>
        </a-layout-footer>
      </a-layout>
  
    </div>
  </template>
  
  <script>
    import headerHeader from "@/components/home/headerHeader"
    import registerHome from "@/components/home/registerHome"
    import footerHome from "@/components/home/footerHome"
    // import register from "./register/register.vue"
    export default {
      name: 'registerF',
      components: {
        headerHeader,
        registerHome,
        footerHome,
        // register,
      },
      data () {
        return {
         
        }
      }
    }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  
  </style>
  